const firstElement = (collection) =>
  collection[0];

export default firstElement;
